var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonFlagUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1954px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1953",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil1 {fill:blue}\n    .fil2 {fill:red}\n    .fil0 {fill:white}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,9 372,9 372,1944 192,1767 9,1944 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "_627177592"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M316 386l-75 0 75 124c0,0 -1,-125 0,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M316 313l-75 0 75 -124c0,0 -1,125 0,124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 386l75 0 -75 124c0,0 1,-125 0,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 313l75 0 -75 -124c0,0 1,125 0,124z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "316,329 316,369 216,369 216,560 168,560 168,369 67,369 67,329 168,329 168,140 216,140 216,329 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "288,141 234,141 234,230 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "288,559 234,559 234,470 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "94,141 149,141 149,230 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "94,559 149,559 149,470 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "298,141 316,141 234,278 233,249 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "316,558 316,528 234,391 233,420 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "84,558 66,558 149,420 149,449 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "66,141 66,170 149,308 149,279 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_627175240"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M316 929l-75 0 75 124c0,0 -1,-126 0,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M316 856l-75 0 75 -124c0,0 -1,125 0,124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 929l75 0 -75 124c0,0 1,-126 0,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 856l75 0 -75 -124c0,0 1,125 0,124z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "316,871 316,912 216,912 216,1103 168,1103 168,912 67,912 67,871 168,871 168,683 216,683 216,871 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "288,684 234,683 234,773 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "288,1102 234,1102 234,1012 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "94,684 149,683 149,773 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "94,1102 149,1102 149,1012 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "298,683 316,683 234,821 233,792 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "316,1101 316,1071 234,933 233,963 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "84,1101 66,1101 149,963 149,992 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "66,683 66,713 149,850 149,821 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_631536680"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M316 1469l-75 0 75 124c0,0 -1,-125 0,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M316 1396l-75 0 75 -124c0,0 -1,125 0,124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 1469l75 0 -75 124c0,0 1,-125 0,-124z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M65 1396l75 0 -75 -124c0,0 1,125 0,124z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "316,1412 316,1452 216,1452 216,1643 168,1643 168,1452 67,1452 67,1412 168,1412 168,1223 216,1223 216,1412 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "288,1224 234,1224 234,1313 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "288,1642 234,1642 234,1553 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "94,1224 149,1224 149,1313 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "94,1642 149,1642 149,1553 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "298,1224 316,1224 234,1361 233,1332 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "316,1641 316,1612 234,1474 233,1503 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "84,1641 66,1641 149,1503 149,1532 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "66,1224 66,1253 149,1391 149,1362 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonFlagUk);
export default __webpack_public_path__ + "static/media/ribbon-flag-uk.b868ad5326c4977075280646a7508133.svg";
export { ForwardRef as ReactComponent };